import { getLocales } from 'assets/locales/Locale';
import ProviderBuilder from 'assets/providers/ProviderBuilder';
import usePublicClaimSubmit from 'module/public-web/views/claimSubmit/Claim.Submit.Hooks';
import { useEffect, useState } from 'react';

export type PublicClaimForm = Module.Claims.Claim.Submit.Form & {
  uploadableClaimTypeDocuments: Model.IClaimTypeDocument[];
};

function usePublicCreateClaimCore() {
  const _original = usePublicClaimSubmit();
  const { lang } = getLocales();
  const steps = [
    { id: 1, title: lang.contract },
    { id: 2, title: lang.claimInfoTitle },
    { id: 3, title: lang.clientInfo },
    { id: 4, title: lang.addJob },
    { id: 5, title: lang.publicClaimReview },
    { id: 6, title: lang.finish },
  ];
  const [currentStep, setCurrentStep] = useState(1);

  const isCreateClaimStepValidated =
    !_original.form.errors.claimCreationOption &&
    !_original.form.errors.claim?.contract?._objectError &&
    !_original.form.errors.newPayee &&
    !_original.form.errors.repairFacilityId &&
    !_original.form.errors.claim?.dealerId;

  const isClaimInfoStepValidated =
    !_original.form.errors.claim?.odometerReading && !_original.form.errors.claim?.workOrderNumber;

  const isClientInfoStepValidated = !_original.form.errors.claim?.createdByPayee;

  const isAddJobStepValidated =
    !_original.form.errors.claim?.claimJobs?._objectError && !_original.form.errors.claim?.claimJobs?.claimTypeId;

  const validatedSteps = [
    isCreateClaimStepValidated,
    isClaimInfoStepValidated,
    isClientInfoStepValidated,
    isAddJobStepValidated,
    false,
    false,
  ];
  const isCurrentStepValidated = !!validatedSteps[currentStep - 1];
  function getResetClaimData() {
    return {
      ..._original.form.data.claim,
      dealerId: null,
      odometerReading: undefined,
      workOrderNumber: undefined,
      createdByPayee: {
        phoneNumber: undefined,
        email: undefined,
        name: undefined,
        payeeTypeId: undefined,
      },
      claimDocuments: [],
      claimJobs: _original.form.data.claim?.claimJobs?.map((it) => ({
        ...it,
        claimJobItems: [],
        claimJobDocuments: [],
        dataPoints: [],
        claimType: undefined,
        claimTypeId: undefined,
        customerComplaint: undefined,
        correction: undefined,
        cause: undefined,
      })),
    };
  }

  useEffect(() => {
    if (_original.form.isSubmitted) {
      setCurrentStep(6);
    }
  }, [_original.form.isSubmitted]);

  return {
    ..._original,
    steps,
    isCurrentStepValidated,
    setCurrentStep,
    currentStep,
    getResetClaimData,
  };
}

const { useProvider: usePublicCreateClaimProvider, Provider: PublicCreateClaimProvider } =
  ProviderBuilder(usePublicCreateClaimCore);

export { PublicCreateClaimProvider, usePublicCreateClaimProvider };
